module.exports = __webpack_public_path__ + "static/img/bg-pt.ce5284be.webp";